import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface StartConfirmEmailForCandidateResponse extends BackendResponse {}

export const startConfirmEmailForCandidate = withNextApi<
  StartConfirmEmailForCandidateResponse>("/cvp/CvpStartEmailVerification");
